import * as type from '../actions/types';

const initialState = {
  data: {},
  pending: false,
  error: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_DEAL_PREDICT_PENDING: {
      return {
        ...state,
        pending: true,
        error: '',
      };
    }
    case type.FETCH_DEAL_PREDICT_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        pending: false,
        success: true,
      };
    }
    case type.FETCH_DEAL_PREDICT_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    }
    case type.CLEAR_DEAL_PREDICT: {
      return {
        ...state,
        data: {},
        pending: false,
        error: '',
        success: false,
      };
    }

    default: {
      return state;
    }
  }
};
